import { render, staticRenderFns } from "./Criar-Evento.vue?vue&type=template&id=0a6f4360&"
import script from "./Criar-Evento.vue?vue&type=script&lang=js&"
export * from "./Criar-Evento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Criar-Evento.vue"
export default component.exports